export class Vehicle {
  id: number
  name: string
  description: string
  
  constructor() {
  }

  static buildOne(obj: any): Vehicle {
    let target: Vehicle = Object.assign(new Vehicle(), obj)
    return target
  }

  static buildMany(objs: any[]): Vehicle[] {
    const lobjs = []
    for (const i in objs) {
      if (objs.hasOwnProperty(i)) {
        lobjs.push(Vehicle.buildOne(objs[i]))
      }
    }
    return lobjs
  }
}

